<template>
    <div class="forgetPwd">
        <div class="forgetPwd-page box">
            <div class="forgetPwd-page_l item">
                <div>  
                    <div class="img_question">
                        <!-- <i class="el-icon-edit-outline "></i> -->
                        <img :src='email' alt="">
                        <p>验证密保问题</p>
                    </div>
                    <p class="tips">您需要填写注册账号时填写的问题和答案进行验证</p>
                    <el-button class="forgetPwd-btn" type="primary"  @click="yzQuestion">立即验证</el-button>
                </div>
                 </div>
            <div class="forgetPwd-page_r item">
                <div>
                    <div class="img_phone">
                        <!-- <i class="el-icon-mobile-phone"></i> -->
                        <img :src='phone' alt="">
                        <p>验证手机号</p>
                    </div>
                    <p class="tips">您需要用绑定的手机进行短信验证</p>
                    <el-button class="forgetPwd-btn" type="primary"  @click="yzPhone">立即验证</el-button>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import phone from '@/assets/img/phone.png'
import email from '@/assets/img/email.png'
export default {

  name: "forgetPwd",
  data() {
    return {
        phone:phone,
        email:email,
    };
  },
  methods: {
    yzQuestion() {
      window.location.href = "https://mail.tongji.edu.cn/coremail/forgetpwd.jsp";
    },
    yzPhone() {
      this.$router.push({ name: 'Step1'});
    }
  }
};
</script>

<style scoped>
.forgetPwd {
  width: 100%;
}
.box {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.item {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item>div{
    width: 60%;
    min-width: 200px;
    height: 300px;
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 10px;
    margin: 10px;
}
.forgetPwd-page {
  background: url("../../assets/img/bigBg/forget_bg.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}


.img_question,
.img_phone {
  text-align: center;
  margin-top: 40px;
}
.img_question i,
.img_phone i{
  font-size: 60px;
  color: #409EFF;
}
.img_question p,
.img_phone p {
    line-height: 50px;
}
.forgetPwd-btn{
    margin-top: 35px;
    width: 80%
}
.tips{
    color: #999;
    font-size: 14px;
    height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/page/reSetPwd/index.vue